import FullWidthCard from 'Components/common/Cards/FullWidthCard/FullWidthCard'
import { NO_TIME_LIMIT_LABEL } from 'Constants/constants'
import { ExamResponseType } from 'Types/Exams.types'
import styles from '../../Home.module.less'
import { ActionButton } from 'Components/common/ActionButton/ActionButton'
import { useNavigate } from 'react-router-dom'
import { secondsToMinutes } from 'Utils/common.utils'
import { useExamProgress } from 'Hooks/exams/use-exam-progress'
import { useCallback } from 'react'

type ExamCardProps = {
    exam: ExamResponseType
}

export const ExamCard = ({ exam }: ExamCardProps) => {
    const navigate = useNavigate()
    const { examProgressTag, isExamInProgress, getTimeLeftInMins } = useExamProgress({
        timeLimitInSeconds: exam.time_limit_in_seconds,
        attempt: exam.attempt,
    })

    const handleExamClick = useCallback(() => navigate(`/exam/${exam.id}`), [exam.id, navigate])

    const handleResumeExam = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()
            const attemptId = exam.attempt?.id
            if (!attemptId) {
                return
            }
            navigate(`/exam/${exam.id}/attempt/${attemptId}`)
        },
        [exam.attempt?.id, exam.id, navigate]
    )

    const isResumable = isExamInProgress && !!getTimeLeftInMins()

    return (
        <div data-testid="exam-card">
            <FullWidthCard
                title={exam.name}
                content={exam.project.description}
                tags={[{ title: exam.project.nickname, type: 'primary' }]}
                extra={examProgressTag ?? undefined}
                footer={
                    <div className={styles['footer']}>
                        <div className={styles['footer-body']}>
                            <div className={styles['footer-content']} key={'duration'}>
                                <span>Exam Duration</span>
                                <span>
                                    {exam.time_limit_in_seconds
                                        ? secondsToMinutes(exam.time_limit_in_seconds) + ' mins'
                                        : NO_TIME_LIMIT_LABEL}
                                </span>
                            </div>
                            <div className={styles['footer-content']} key={'questions'}>
                                <span>No of Questions</span>
                                <span>{exam.num_of_questions}</span>
                            </div>
                            {isResumable && (
                                <div
                                    className={
                                        styles['footer-content'] +
                                        ' ' +
                                        styles['resume-exam-button']
                                    }
                                    key={'resume-exam-button'}
                                >
                                    <ActionButton
                                        color="primary"
                                        title="Resume Exam"
                                        onClick={handleResumeExam}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                }
                onClick={handleExamClick}
            />
        </div>
    )
}
